import React, { useState, useEffect } from 'react';
import { ChakraProvider, PortalManager, useDisclosure } from '@chakra-ui/react';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { WhatsAppProvider } from './contexts/WhatsAppContext';
import { AppRoutes } from './routes';
import AvisoNovaVersao from './components/AvisoNovaVersao';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SimpleSubscriptionModal, { setSubscriptionModalControls } from './components/SimpleSubscriptionModal';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });
  
  // Hook para controlar o modal de assinatura
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  // Configurar as funções de controle do modal ao montar o componente
  useEffect(() => {
    setSubscriptionModalControls(onOpen, onClose);
    
    return () => {
      // Limpar no desmonte
      if (window.openSubscriptionModal === onOpen) {
        delete window.openSubscriptionModal;
      }
    };
  }, [onOpen, onClose]);
  
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider resetCSS theme={theme}>
        <PortalManager zIndex={1500}>
          <AuthProvider>
            <WhatsAppProvider>
              <AppRoutes />
              <AvisoNovaVersao />
              {/* Modal de assinatura acessível globalmente */}
              <SimpleSubscriptionModal isOpen={isOpen} onClose={onClose} />
            </WhatsAppProvider>
          </AuthProvider>
        </PortalManager>
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;
